var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankReconciliation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#E5F0EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.75 35.5h-4.5V49a4.5 4.5 0 0 0-4.5 4.5v2.25a4.5 4.5 0 0 0 4.5 4.5h31.5a4.5 4.5 0 0 0 4.5-4.5V53.5a4.5 4.5 0 0 0-4.5-4.5V35.5h-4.5V49h-4.5V35.5h-4.5V49h-4.5V35.5h-4.5V49h-4.5V35.5Z",
    fill: "#006C52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 29.703a4.5 4.5 0 0 1 3.026-4.252l15.75-5.46a4.5 4.5 0 0 1 2.948 0l15.75 5.46a4.5 4.5 0 0 1 3.026 4.252V31a4.5 4.5 0 0 1-4.5 4.5h-31.5a4.5 4.5 0 0 1-4.5-4.5v-1.297Z",
    fill: "#A0C9BF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankReconciliation);
export default __webpack_public_path__ + "static/media/bank-reconciliation.45754713.svg";
export { ForwardRef as ReactComponent };